<template>
  <div>
    <section class="no-print">
      <v-row align="end" justify="space-between" no-gutters class="mb-2">
        <v-btn
          v-if="$vuetify.breakpoint.smAndUp"
          @click="printView = !printView"
          small
          class="ml-1"
          :color="printView === true ? '' : 'success'"
          text
        >
          <v-icon left x-small>fa-columns</v-icon>
          <span v-if="printView">Vue détaillée</span>
          <span v-else>Vue simple</span>
        </v-btn>
        <div>
          <ProductionDialog></ProductionDialog>
          <InventoryWasteDialog></InventoryWasteDialog>
        </div>
      </v-row>
    </section>
    <section v-if="preparationSlip && preparationSlipTemplate">
      <v-card flat>
        <v-card-title class="py-1">
          <v-row align="center" justify="space-between" dense no-gutters>
            <span :class="{ 'subtitle-1': $vuetify.breakpoint.xsOnly }">
              Bon du {{ formatDate(preparationSlip.date) }}</span
            >
            <v-spacer></v-spacer>
            <v-btn
              v-if="$vuetify.breakpoint.xsOnly"
              @click="printView = !printView"
              icon
              text
              small
              :color="printView === true ? '' : 'success'"
            >
              <v-icon small>fa-columns</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters dense justify="space-between">
            <span class="caption">Créé par: {{ preparationSlip.author }}</span>
            <span class="caption"
              >Gabarit: {{ preparationSlipTemplate.name }}</span
            >
          </v-row>
          <v-divider class="my-1"></v-divider>
          <v-row no-gutters dense class="mt-3">
            <span class="overline font-weight-medium primary--text"
              >Préparations</span
            >
          </v-row>
          <!-- <PreparationSlipViewerViewer
            :template.sync="template"
            :items="preparationSlipProducts.filter(x => x.quantity > 0)"
            :print-view="printView"
          ></PreparationSlipViewerViewer> -->
          <PreparationSlipViewerGrid
            :items="preparationSlipProducts.filter(x => x.quantity > 0)"
            :hideDetails="printView"
            :dense="printView"
            infinite
          ></PreparationSlipViewerGrid>
        </v-card-text>
        <v-card-text class="no-print">
          <v-row no-gutters dense class="mb-1">
            <span class="overline font-weight-medium primary--text"
              >Préparations planifiées</span
            >
          </v-row>
          <PreparationSlipViewerScheduledPrepGrid
            :date="preparationSlip.date"
          ></PreparationSlipViewerScheduledPrepGrid>
        </v-card-text>
        <v-card-text class="no-print">
          <v-row no-gutters dense class="mb-1">
            <span class="overline font-weight-medium primary--text"
              >Expirations</span
            >
          </v-row>
          <PreparationSlipViewerExpirationGrid
            :date="preparationSlip.date"
          ></PreparationSlipViewerExpirationGrid>
        </v-card-text>
        <v-card-text
          v-if="
            preparationSlipTemplate !== undefined &&
              preparationSlipTemplate.instructions.blocks !== undefined &&
              preparationSlipTemplate.instructions.blocks.length > 0
          "
        >
          <span class="overline font-weight-medium primary--text mb-1"
            >Instructions supplémentaires</span
          >
          <RecipeInstructionsRenderer
            :instructions="preparationSlipTemplate.instructions"
          ></RecipeInstructionsRenderer>
        </v-card-text>
        <v-card-text
          v-if="
            preparationSlip.comments !== null && preparationSlip.comments !== ''
          "
        >
          <span class="overline font-weight-medium primary--text mb-1"
            >Commentaires supplémentaires</span
          >
          <p>{{ preparationSlip.comments }}</p>
        </v-card-text>
      </v-card>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/api";
import moment from "moment";
import {
  PreparationSlipViewerGrid,
  PreparationSlipViewerExpirationGrid,
  PreparationSlipViewerScheduledPrepGrid
} from "../components";
import { RecipeInstructionsRenderer } from "@/modules/Recipes/components";
import {
  InventoryWasteDialog,
  ProductionDialog
} from "@/modules/Inventory/components";
export default {
  name: "PreparationSlipViewer",
  components: {
    InventoryWasteDialog,
    ProductionDialog,
    RecipeInstructionsRenderer,
    PreparationSlipViewerGrid,
    PreparationSlipViewerExpirationGrid,
    PreparationSlipViewerScheduledPrepGrid
  },
  props: {
    id: {
      required: true
    }
  },
  created() {
    if (this.id !== null) {
      this.getData();
    }
  },
  computed: {
    ...mapGetters([
      "getInventoryTemplates",
      "getPreparationSlipTemplates",
      "getProducts",
      "getIngredients",
      "getRecipes",
      "getPreparationSlipProductUpdateFlag"
    ])
  },
  data() {
    return {
      preparationSlip: undefined,
      preparationSlipTemplate: undefined,
      preparationSlipProducts: [],
      templateId: null,
      template: [{ tags: [] }],
      printView: true
    };
  },
  methods: {
    async getData() {
      if (this.id !== null) {
        try {
          this.$store.dispatch("slo");
          await Promise.all([
            this.$store.dispatch("loadExpirations"),
            this.$store.dispatch("loadInventoryTemplates", {
              store: this.getStoreId
            }),
            this.$store.dispatch("loadAllRecipeStore")
          ]);
          this.preparationSlip = await api.retrievePreparationSlip(this.id);
          this.preparationSlipTemplate = await api.retrievePreparationSlipTemplate(
            this.preparationSlip.fk_preparation_slip_template
          );
          this.preparationSlipProducts = this.preparationSlip.preparation_slip_products
            .map(x => {
              const originProduct = this.getProducts.find(
                p => p.id === x.fk_product
              );
              const templateInfos = this.preparationSlipTemplate.preparation_slip_template_products.find(
                t => t.fk_product === x.fk_product
              );
              if (originProduct.est_intermediaire === true) {
                return {
                  ...originProduct,
                  ...x,
                  quantity_asked: templateInfos
                    ? Number(templateInfos.quantity)
                    : null,
                  quantity: Number(x.quantity),
                  quantity_inventory: Number(
                    x.quantity_inventory ? x.quantity_inventory : 0
                  ),
                  ratio:
                    Number(x.quantity) > 0
                      ? (Number(
                          x.quantity_inventory ? x.quantity_inventory : 0
                        ) /
                          Number(x.quantity)) *
                        100
                      : 999
                };
              } else {
                return null;
              }
            })
            .filter(x => x !== null);
        } finally {
          this.$store.dispatch("elo");
        }
      }
    },
    async updateData() {
      const res = await api.retrievePreparationSlip(this.id);
      res.preparation_slip_products.forEach(p => {
        let currentProductData = this.preparationSlipProducts.find(
          x => x.fk_product === p.fk_product
        );
        if (currentProductData) {
          currentProductData.is_deleted = p.is_deleted;
          currentProductData.is_done = p.is_done;
        }
      });
    },
    formatDate(date) {
      return moment(date).format("ll");
    }
  },
  watch: {
    templateId(v) {
      if (v && v !== null) {
        this.template = this.getInventoryTemplates.find(
          x => x.id === v
        ).templates;
      } else {
        this.template = [{ tags: [] }];
      }
    },
    getPreparationSlipProductUpdateFlag(v) {
      if (v === true) {
        this.updateData();
        this.$store.commit("setPreparationSlipProductUpdateFlag", false);
      }
    }
  }
};
</script>

<style></style>
